import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DiamondIcon from '@mui/icons-material/Diamond';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';

const defaultStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '88%', sm: 520 },
  bgcolor: '#fff',
  borderRadius: '20px',
  boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
  p: { xs: 2.5, sm: 4 },
  outline: 'none'
};

const UpgradeModal = ({
  open,
  onClose,
  title = 'Generate Video',
  errorMessage = 'You don’t have enough credits to generate this video. Please upgrade your plan to continue.',
  upgradeButtonText = 'Upgrade'
}) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    navigate('/pricing');
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="upgrade-modal-title"
      aria-describedby="upgrade-modal-description">
      <Box sx={defaultStyle}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <Typography id="upgrade-modal-title" variant="h6" component="h2" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>

          <IconButton
            onClick={onClose}
            sx={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#999'
            }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            bgcolor: '#FDEBEC',
            border: '1px solid #F5C6CB',
            color: '#8A1F2B',
            borderRadius: '12px',
            p: 2,
            mb: 3
          }}>
          <InfoOutlinedIcon sx={{ mr: 1, color: '#8A1F2B' }} />
          <Typography
            id="upgrade-modal-description"
            sx={{ fontSize: { xs: 13, sm: 14 }, lineHeight: 1.6 }}>
            {errorMessage}
          </Typography>
        </Box>

        <Button
          fullWidth
          variant="contained"
          onClick={handleUpgrade}
          startIcon={<DiamondIcon sx={{ color: '--white' }} />}
          sx={{
            bgcolor: 'var(--btn-purple-color)',
            color: '#fff',
            borderRadius: '999px',
            py: 1.5,
            textTransform: 'none',
            fontWeight: 700,
            fontSize: 16,
            '&:hover': {
              bgcolor: 'var(--btn-purple-hover-color)'
            }
          }}>
          {upgradeButtonText}
        </Button>
      </Box>
    </Modal>
  );
};

export default UpgradeModal;
